import "./index.css";
import { Tooltip } from "antd";

export const SSOLabel = () => {
  return (
    <div>
      <ApplicationLabelTooltip
        title={"SSO"}
        className={"greenCircleLabel"}
      />
    </div>
  );
};

export const NonSSOLabel = () => {
  return (
    <div>
      <ApplicationLabelTooltip
        title={"Non-SSO"}
        className={"orangeCircleLabel"}
      />
    </div>
  );
};

const ApplicationLabelTooltip = ({ title, className }) => {
  return (
    <Tooltip
      placement="top"
      title={title}
    >
      <div className={className}/>
    </Tooltip>
  );
};
